import * as React from 'react';
import { Image } from '../../components/forms';
import Section from '../../components/Section';
import { Product } from '../../product';
import HelpHint from '../../components/HelpHint';

type Props = {
  product: Product;
  setProduct: Function;
};

const setValue = (obj: Product, onChange: Function) => (
  field: string,
  newValue: any,
) => {
  const dat: Product = Object.assign({}, obj, {
    [field]: newValue,
  });

  if (field !== 'image_url') {
    if (dat.images.length === 1) {
      dat.image_url = dat.images[0];
    }

    if (!dat.images.length) {
      dat.image_url = null;
    }
  }

  onChange(dat);
};

export default function ProductImagery(props: Props) {
  const handleOnChange = setValue(props.product, props.setProduct);
  const appendImage = (_: string, newImage: string) =>
    handleOnChange('images', props.product.images.concat([newImage]));
  const removeImage = (index: number) => () =>
    handleOnChange(
      'images',
      props.product.images.filter(
        (_: string, itemIndex: number) => itemIndex !== index,
      ),
    );
  const setMainProduct = (url: string) => () =>
    handleOnChange('image_url', url);

  return (
    <Section title="Images" id="imagery">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-ns w-100 pr2">
          <div>
            {props.product.images.map((imageURL: string, index: number) => (
              <div className="dib ba b--black-10 br3 mr2 mb2 db black hover-bg-black-10 tc">
                <img src={imageURL} className="w4 ma3 db" />

                <div className="mv2">
                  <input
                    type="radio"
                    name="main_image"
                    id={`main_image_${index}`}
                    onChange={setMainProduct(imageURL)}
                    defaultChecked={props.product.image_url === imageURL}
                  />
                  <label className="ml3" htmlFor={`main_image_${index}`}>
                    Main Image
                  </label>
                </div>

                <button
                  type="button"
                  className="w-100 red b dib link bg-transparent bw0 pointer dim mv2 pa1 pa3-ns w3"
                  onClick={removeImage(index)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
        <div className="flex-auto w-30-ns w-100 pl2">
          {props.product.images.length < 9 && (
            <Image
              label="Image"
              id="image_identifier"
              field={['image_identifier']}
              defaultValue={null}
              onValueChange={appendImage}
            />
          )}
          <HelpHint>
            Please ensure iamges are in square format with at least 500px by
            500px in size.
            <br />
            <br />
            You can upload up to 8 images.
          </HelpHint>
        </div>
      </div>
    </Section>
  );
}
